import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords = '', 
  canonical = '',
  ogImage = '/assets/images/logo.png',
  ogType = 'website'
}) => {
  // Ensure title has the brand name
  const fullTitle = title.includes('iScreenFix') ? title : `${title} | iScreenFix`;
  
  // Default canonical URL if not provided
  const fullCanonical = canonical || window.location.href.split('?')[0];
  
  return (
    <Helmet>
      {/* Basic metadata */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullCanonical} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullCanonical} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
      
      {/* Location data for local business */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "iScreenFix",
            "image": "${window.location.origin}/assets/images/logo.png",
            "url": "https://www.iscreenfix.com",
            "telephone": "(843) 306-6716",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "981 Hackler Street Unit E",
              "addressLocality": "Myrtle Beach",
              "addressRegion": "SC",
              "postalCode": "29577",
              "addressCountry": "US"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 33.6895,
              "longitude": -78.8867
            },
            "openingHoursSpecification": [
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                  "Sunday"
                ],
                "opens": "10:00",
                "closes": "18:00"
              },
            ]
          }
        `}
      </script>
    </Helmet>
  );
};

export default SEO; 